/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-03 12:00:00
 *
 *******************************************************/

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { routes } from 'src/routes';
import history from 'src/routes/history';
import IconRunning from 'src/assets/images/common/running.svg';

type Props = {
  tenantApp: Object
};

type ComposedProps = Props & WithI18nProps;

class BannerUpgradeRunning extends Component<ComposedProps> {
  handleAction = () => {
    history.push(routes.landingPage.view());
  };
  render() {
    const { i18n, theme } = this.props;

    return (
      <div className='theme-settup-upgrade-running'>
        <div className="title">
          <img className='running' src={IconRunning} alt="running" />
          <span>{i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.list_banner_running_title')}</span>
        </div>
        <div className="content">
         <span>{i18n.translate('AdminHTML.ThemeSetup.NewThemeSetup.list_banner_running_content', {
              t: (
                <TextStyle variation="strong">{theme.name}</TextStyle>
              )
            })}</span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  tenantApp: _.get(state.oauth, 'tenantApp', {})
});

export default connect(mapStateToProps)(withI18n()(BannerUpgradeRunning));
